export default __webpack_public_path__ + "static/media/PadronSeries_4000.97f59716.jpg";